module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-down-6cd90dc166e8cfbf458f866cc048c3aa.svg";